import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { APPLE_PAY, CB, GOOGLE_PAY, COFIDIS, CRYPTO_LYZI } from '../../../constants/paymentMethods';

import ApplePayButton from './ApplePayButton';
import NextStepButton from './NextStepButton';
import GooglePayButton from './GooglePayButton';

import { ButtonWrapper } from './ButtonContainerStyle';

const ValidationButton = ({
    setStateOfTransaction,
    paymentType,
    cartTotalValue,
    userInfo,
    partnerId,
    order
}) => {
    const showNextStepButton = !paymentType || [CB, COFIDIS, CRYPTO_LYZI].includes(paymentType);
    const showApplePayButton = [APPLE_PAY].includes(paymentType);
    const showGooglePayButton = [GOOGLE_PAY].includes(paymentType);

    return (
        <ButtonWrapper>
            {showNextStepButton && (
                <NextStepButton
                    paymentType={paymentType}
                    setStateOfTransaction={setStateOfTransaction}
                />
            )}

            {showApplePayButton && (
                <ApplePayButton
                    userInfo={userInfo}
                    partnerId={partnerId}
                    cartTotalValue={cartTotalValue}
                    order={order}
                />
            )}

            {showGooglePayButton && (
                <GooglePayButton
                    userInfo={userInfo}
                    partnerId={partnerId}
                    cartTotalValue={cartTotalValue}
                />
            )}
        </ButtonWrapper>
    );
};

ValidationButton.propTypes = {
    setStateOfTransaction: PropTypes.func,
    paymentType: PropTypes.string,
    cartTotalValue: PropTypes.number,
    userInfo: PropTypes.object,
    partnerId: PropTypes.number
};

const mapStateToProps = state => {
    return {};
};

export default connect(mapStateToProps)(ValidationButton);



// WEBPACK FOOTER //
// ./src/components/funnel/buttons/ButtonContainer.js